<template>
  <div class="abnormal__div--box">
    <div class="checkbox__div">
      <el-radio v-model="abnormalType" v-for="item in abnormalTypes" :label="item.value" @change="submit" :key="item.value">{{ item.label }}</el-radio>
    </div>
    <el-input maxlength='450' type="textarea" :autosize="{ minRows: 5 }" v-model="textarea" placeholder="备注" @change="submit"/>
    <div class="btn__div">
      <IptNumber v-model="abnormalAmount" @change="submit"/>
      <el-button type="primary" @click="submit">发起异常</el-button>
    </div>
  </div>
</template>

<script>
import IptNumber from "@/components/IptNumber";
export default {
  name: "TransferAbnormal",
  components: {
    IptNumber
  },
  data () {
    return {
      textarea: '',
      abnormalType: '',
      abnormalTypes: [
        {
          label: '多件',
          value: '多件'
        },
        {
          label: '少件',
          value: '少件'
        }
      ],
      abnormalAmount: 0
    }
  },
  methods: {
    submit: function () {
      const {textarea, abnormalType, abnormalAmount} = this
      this.$emit('submit', {
        textarea, abnormalType, abnormalAmount
      })
    }
  }
}
</script>

<style scoped>
.abnormal__div--box {
  display: grid;
  grid-template-columns: auto 300px 125px;
  grid-template-rows:  120px;
  grid-column-gap: 14px;
}
.checkbox__div {
  background: #fafafa;
  padding: 20px;
  border-radius: 6px;
}
.btn__div {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
}
.el-button+.el-button {
  margin-left: 0px;
}
</style>